import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { DateTime } from 'luxon';

import { url } from '../../../../shared/src/lib/helpers/url';
import { SharedSettings } from '../../../../shared/src/lib/models/shared-settings';

@Injectable({
    providedIn: 'root'
})
export class FileManagerService {

    constructor(private http: HttpClient, private settings: SharedSettings) { }

    UploadFile(fileType: string, file: File, siteId?: string, subinventoryId?: number, entityId?: number): Observable<any> {
        const formdata = new FormData();
        const urlString = this.makeUrl(fileType, siteId, subinventoryId, null, entityId);
        formdata.append('import', file);
        return this.http.post<object>(this.settings.apiBaseUrl + url`fileupload/` + urlString, formdata);
    }

    UploadBlob(siteId: string, fileType: string, file: File, entityParent: string, entityId: number): Observable<string> {
        const formdata = new FormData();
        const urlString = this.makeUrl(fileType, siteId,null, entityParent, entityId);
        formdata.append('import', file);
        return this.http.post<string>(this.settings.apiBaseUrl + url`blobStorage/fileUpload/` + urlString, formdata);
    }

    private makeUrl(fileType: string, siteId?: string, subinventoryId?: number, entityParent?: string, entityId?: number): string {
        let urlstring = `${fileType}`;

        if (siteId)
            urlstring += url`/${siteId}`;

        if (subinventoryId)
            urlstring += url`/${subinventoryId}`;

        if (entityParent)
            urlstring += url`/${entityParent}`;

        if (entityId)
            urlstring += url`/${entityId}`;

        if (fileType === 'cheploads')
            urlstring += url`?updateDate=${DateTime.local().toISODate()}`;

        return urlstring;
    }
}
